import React from 'react';
import { useSelector, useDispatch } from 'redux/hooks';
import { getSearchAndBrowseLoading } from 'redux/modules/search-and-browse/selectors';
import { navigateToMultiSearch } from 'redux/modules/multi-search/actions/navigate-to-multi-search';
import {
  getMultiSearchCurrentValue,
  getMultiSearchValues,
} from 'redux/modules/multi-search/selectors';
import classNames from 'classnames';
import HorizontalSlider from 'components/MultiSearch/HorizontalSlider';
import MultiSearchButton from 'components/MultiSearch/Button';
import SkipLink from 'components/SkipLink';

import styles from './MultiSearchStrip.scss';

const MultiSearchStrip = ({ showNewHeader }) => {
  const loading = useSelector(getSearchAndBrowseLoading);
  const values = useSelector(getMultiSearchValues);
  const current = useSelector(getMultiSearchCurrentValue);
  const dispatch = useDispatch();

  return values && values.length ? (
    <div className={classNames(styles.outer, { [styles.withNewHeader]: showNewHeader })}>
      <div className={classNames({ [styles.container]: showNewHeader }, 'container-fluid')}>
        <SkipLink destination="#main">Skip to main content</SkipLink>
        <HorizontalSlider
          resetKey={JSON.stringify(values)}
          wrapperClass={classNames({ [styles.sliderWrapper]: showNewHeader })}
        >
          <ol
            className={classNames(styles.strip, { [styles.withNewHeader]: showNewHeader })}
            data-testid="multi-search-strip"
          >
            {values.map(value => (
              <li
                className={classNames(styles.value, { [styles.withNewHeader]: showNewHeader })}
                key={value}
              >
                <MultiSearchButton
                  onClick={() => dispatch(navigateToMultiSearch(value, { preserveParams: true }))}
                  selected={value === current}
                  value={value}
                  loading={loading}
                />
              </li>
            ))}
          </ol>
        </HorizontalSlider>
      </div>
    </div>
  ) : null;
};

export default MultiSearchStrip;
